import React, { type JSX } from "react";

export default function SupDownArrowAltSquare(props: { className?: string }): JSX.Element {
  return (
    <svg width="12" className={props.className} height="12" stroke="currentColor" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.71192 8.12846L2.625 4.42416L2.04884 4.9043L6.08692 9.75L10.125 4.9043L9.54883 4.42416L6.46192 8.12846V2.25H5.71192V8.12846Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H12V12H0V0ZM0.75 0.75H11.25V11.25H0.75V0.75Z" fill="currentColor" />
      <path d="M5.71192 8.12846L2.625 4.42416L2.04884 4.9043L6.08692 9.75L10.125 4.9043L9.54883 4.42416L6.46192 8.12846V2.25H5.71192V8.12846Z" stroke="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H12V12H0V0ZM0.75 0.75H11.25V11.25H0.75V0.75Z" stroke="currentColor" />
    </svg>
  );
}
